import type { CSSProperties, JSX } from "react";
import styles from "./IntentStrip.module.css";
import { TEST_IDS } from "../testing/testIds";

const MAX_DISPLAY_LABEL_LEN = 40;

function formatLabel(intents: string[]): string {
  if (intents.length === 0) return "";
  if (intents.length === 1) {
    const label = intents[0].length > MAX_DISPLAY_LABEL_LEN
      ? intents[0].slice(0, MAX_DISPLAY_LABEL_LEN) + "…"
      : intents[0];
    return label;
  }
  if (intents.length === 2) {
    const first = intents[0].length > MAX_DISPLAY_LABEL_LEN
      ? intents[0].slice(0, MAX_DISPLAY_LABEL_LEN) + "…"
      : intents[0];
    return `${first}, and ${intents[1]}`;
  }
  const first = intents[0].length > MAX_DISPLAY_LABEL_LEN
    ? intents[0].slice(0, MAX_DISPLAY_LABEL_LEN) + "…"
    : intents[0];
  return `${first}, and ${intents.length - 1} more`;
}

type IntentStripProps = {
  intents: string[];
  style?: CSSProperties;
  dark?: boolean;
};

export function IntentStrip({ intents, style, dark }: IntentStripProps): JSX.Element | null {
  if (intents.length === 0) return null;

  const displayLabel = `sitting with · ${formatLabel(intents)}`;
  const ariaLabel = `You are sitting with: ${intents.join(", ")}`;

  return (
    <div
      className={`${styles.strip}${dark ? ` ${styles["strip--dark"]}` : ""}`}
      style={style}
      aria-label={ariaLabel}
      data-testid={TEST_IDS.INTENT_STRIP}
    >
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.label}>{displayLabel}</span>
    </div>
  );
}
